module.exports = __webpack_public_path__ + "img/evanthia_dimara.083e77d6.png";